import React, { useState } from "react";

export const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  const [isToggled, setIsToggled] = useState(false);

  return (
    <div className="border-b border-gray-200 mb-4">

      {/* Header Section */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between 
                      gap-3 px-4 sm:px-6 py-4">

        {/* Title + Description */}
        <div className="min-w-0">
          <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#424242]">
            Domain Management
          </h1>

          <p className="text-sm text-gray-600 mt-1 max-w-2xl">
            Detailed overview of the selected asset under the chosen product and
            domain hierarchy.
          </p>
        </div>

        {/* Toggle (if needed later) */}
        <label className="flex items-center cursor-pointer select-none">
          <input
            type="checkbox"
            className="sr-only"
            checked={isToggled}
            onChange={() => setIsToggled(!isToggled)}
          />
        </label>
      </div>

      {/* Tabs Section */}
      <div className="px-4 sm:px-6 pb-3">
        <nav
          className="
            flex gap-2 overflow-x-auto scrollbar-hide
            whitespace-nowrap
          "
        >
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex items-center gap-2 shrink-0
                px-4 py-2 text-sm font-medium
                border transition-all duration-200
                ${
                  activeTab === tab.id
                    ? "bg-[#E6E8FA] text-[#bb1ccc] border-[#0F0791] rounded-lg"
                    : "bg-white text-[#404040] border-[#818181] hover:bg-gray-50 rounded-lg"
                }
              `}
            >
              {tab.label}

              {tab.count && (
                <span className="px-2 py-0.5 text-xs bg-[#DBDBDB] text-[#404040] rounded">
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};
